import { v4 as uuid } from 'uuid';

export function wrapComponentsForDashboard(components: any[], variationConfig: any): any {
  if (variationConfig.variation !== 'flow') return [];

  const span = 12 / Number(variationConfig.layoutType); // e.g. 12 / 3 = 4
  const row: any = {
    type: 'fgrow',
    id: uuid(),
    name: 'Dashboard Row',
    logo: 'fgrow',
    icon: 'fa fa-bars',
    config: false,
    uuid: uuid(),
    children: []
  };

  for (let i = 0; i < components.length; i++) {
    const col = {
      type: 'fgcol',
      id: uuid(),
      span: span.toString(),
      icon: 'fa fa-columns',
      config: false,
      name: `${span} Columns`,
      logo: 'fgcol',
      children: [components[i]],
      uuid: uuid()
    };

    row.children.push(col);
  }

  // Adjust the last row if its span total is less than 12
  let lastRowStart = Math.floor((components.length - 1) / variationConfig.layoutType) * variationConfig.layoutType;
  let lastRowCols = row.children.slice(lastRowStart);
  let currentSpan = lastRowCols.reduce((sum, c) => sum + Number(c.span), 0);

  if (currentSpan < 12) {
    const remaining = 12 - currentSpan;
    lastRowCols[lastRowCols.length - 1].span = (Number(lastRowCols[lastRowCols.length - 1].span) + remaining).toString();
  }

  return [row];
}




function shuffleArray<T>(array: T[]): T[] {
  const clone = [...array];
  for (let i = clone.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [clone[i], clone[j]] = [clone[j], clone[i]];
  }
  return clone;
}

export function wrapComponentsForBento(components: any[], variationConfig: any): any[] {
 // if (variationConfig.variation !== 'bento') return [];

  const shuffled = shuffleArray(components);
  const layoutPreset = variationConfig.presets[Math.floor(Math.random() * variationConfig.presets.length)];

  const result: any[] = [];
  let index = 0;

  for (const rowSpans of layoutPreset) {
    const row = {
      type: 'fgrow',
      id: uuid(),
      name: 'Bento Row',
      logo: 'fgrow',
      icon: 'fa fa-bars',
      config: false,
      uuid: uuid(),
      children: []
    };

    for (const span of rowSpans) {
      const comp = shuffled[index];
      if (!comp) break;

      row.children.push({
        type: 'fgcol',
        id: uuid(),
        span: span.toString(),
        icon: 'fa fa-columns',
        config: false,
        name: `${span} Columns`,
        logo: 'fgcol',
        children: [comp],
        uuid: uuid()
      });

      index++;
    }

    result.push(row);
    if (index >= shuffled.length) break;
  }

  return result;
}

const chartSpanMap = {
 "Pie_Chart":[3,4,5,6],
    "Advanced_Pie_Chart":[6,7,8,9,10,11,12],
    "Pie_Grid":[6,7,8,9,10,11,12],
    "tree-map":[3,4,5,6,7,8,9,10,11,12],
    "number-card":[6,7,8,9,10,11,12],
    "gauge":[3,4,5,6],
    "Vertical_Bar_Chart":[6,7,8,9,10,11,12],
    "Horizontal_Bar_Chart":[6,7,8,9,10,11,12],
    "Grouped_Vertical_Bar_Chart":[6,7,8,9,10,11,12],
    "Grouped_Horizontal_Bar_Chart":[6,7,8,9,10,11,12],
    "Stacked_Vertical_Bar_Chart":[6,7,8,9,10,11,12],
    "Stacked_Horizontal_Bar_Chart":[6,7,8,9,10,11,12],
    "Normalized_Vertical_Bar_Chart":[6,7,8,9,10,11,12],
    "Normalized_Horizontal_Bar_Chart":[6,7,8,9,10,11,12],
        "line-chart":[6,7,8,9,10,11,12],
    "polar-chart":[3,4,5,6],
    "area-chart":[3,4,5,6,7,8,9,10,11,12],
    "area-chart-stacked":[3,4,5,6,7,8,9,10,11,12],
    "area-chart-normalized":[3,4,5,6,7,8,9,10,11,12],
    "heat-map":[4,5,6,7,8,9,10,11,12],
    "box-chart":[4,5,6,7,8,9,10,11,12]
  // ... etc
};

const presetDefinition = {
    bento1: {
        minrow:1,
        maxrow:1,
        presets : [
            [[6, 6]],
        ]
    }
}
export function createrBentoLayout(components: any[]): any[] {

    return generateBentoLayoutWithMultipleRows(components);
    
}
export function generateBentoLayoutWithMultipleRows(components: any[]): any[] {
  const presets = [
    [[6, 6]],
    [[4, 4, 4]],
    [[4, 8]],
    [[8, 4]],
    [[5, 4 , 3]],
    [[8, 4], [4, 8]],
    [[4, 8], [6, 6], [8,4]],
  ];

  const minRows = 5;
  const maxRows = 10;
  const selectedPresets: number[][][] = [];

  // Pick random presets until we have enough rows (3 to 6)
  while (true) {
    const preset = presets[Math.floor(Math.random() * presets.length)];
    selectedPresets.push(preset);

   const totalRows = selectedPresets.reduce((acc, preset) => acc + preset.length, 0);
    if (totalRows >= minRows) {
      if (totalRows >= maxRows || Math.random() > 0.5) break;
    }
  }

  const layout = [];
  const componentPool = [...components];

  for (const preset of selectedPresets) {
    for (const row of preset) {
      const rowChildren = row.map(span => {
       const validIndex = componentPool.findIndex(c => {
  const allowedSpans = chartSpanMap[c.chartSubtype || c.selectedVariation || c.isOptionChart] || [];
  return allowedSpans.includes(span);
});

let comp = null;
if (validIndex !== -1) {
  comp = componentPool.splice(validIndex, 1)[0]; // Remove from pool
}
        return {
          type: 'fgcol',
          id: crypto.randomUUID(),
          span: span.toString(),
          icon: 'fa fa-columns',
          config: false,
          name: `${span} Columns`,
          logo: 'fgcol',
          children: comp ? [comp] : [],
          uuid: crypto.randomUUID()
        };
      });

      layout.push({
        type: 'fgrow',
        id: crypto.randomUUID(),
        name: 'Row',
        logo: 'fgrow',
        children: rowChildren,
        uuid: crypto.randomUUID()
      });
    }
  }

  return layout;
}
export function generateRowLayoutFromPreset(
  components: any[],
  preset: number[],
  itemsPerCol: number = 1
): any {
  const componentPool = [...components];
  const layout = {
    type: 'fgrow',
    id: crypto.randomUUID(),
    name: 'Row',
    logo: 'fgrow',
    uuid: crypto.randomUUID(),
    children: [] as any[],
  };

  for (const span of preset) {
    const colChildren: any[] = [];

    for (let i = 0; i < itemsPerCol; i++) {
      const matchingComps = componentPool.filter((c) => {
        const subtype = c.chartSubtype || c.selectedVariation || c.isOptionChart;
        const allowedSpans = chartSpanMap[subtype] || [];
        return allowedSpans.includes(span);
      });

      if (matchingComps.length === 0) break;

      const randomIndex = Math.floor(Math.random() * matchingComps.length);
      const selected = matchingComps[randomIndex];
      const poolIndex = componentPool.findIndex((c) => c === selected);

      if (poolIndex !== -1) {
        const picked = componentPool.splice(poolIndex, 1)[0];
        colChildren.push(picked);
      }
    }

    layout.children.push({
      type: 'fgcol',
      id: crypto.randomUUID(),
      span: span.toString(),
      icon: 'fa fa-columns',
      config: false,
      name: `${span} Columns`,
      logo: 'fgcol',
      uuid: crypto.randomUUID(),
      children: colChildren,
    });
  }

  return layout;
}